<template>
  <div class="lg:flex bg-white gap-8 pt-28 pb-10 lg:px-12 md:px-8 px-5">
    <div class="lg:w-4/5">
      <h2 class="text-primary fsize24 font-semibold">Plan Overview</h2>
      <div class="custplanoverview mt-4">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
          alt=""
          class="w-full h-200px custimgradius1"
        />
        <div class="px-4 py-2">
          <p class="text-black font-semibold fsize22">Explore</p>
          <div class="flex gap-1 py-1">
            <p class="text-primary">Valid till :</p>
            <p>31st Dec,2024</p>
          </div>
          <p clas>
            Designed exclusively for visitors seeking a glimpse into our
            offerings
          </p>
        </div>
      </div>
      <div class="pt-5">
        <el-collapse
          class="custelcollapse"
          v-model="activeNames"
          @change="handleChange"
        >
          <el-collapse-item title="Benefits" name="1">
            <div class="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-4">
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Career Option</p>
                </div>
              </div>
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Volunteer with Us</p>
                </div>
              </div>
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Donate</p>
                </div>
              </div>
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Donate</p>
                </div>
              </div>
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Donate</p>
                </div>
              </div>
              <div class="custplanoverview mt-4">
                <img
                  src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
                  alt=""
                  class="w-full h-130px custimgradius1"
                />
                <div class="p-2">
                  <p class="text-black fsize16">Donate</p>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="pt-5">
        <h2 class="fsize28 sm-fsize20px font-semibold text-primary">FAQ's</h2>
        <div class="pt-3">
          <el-collapse
            class="custelcollapse1"
            v-model="activeNames"
            @change="handleChange"
          >
            <el-collapse-item
              title="Frequently Ask Questions"
              name="1"
              class="pb-2"
            >
              <div class="pl-3">
                Consistent with real life: in line with the process and logic of
                real life, and comply with languages and habits that the users
                are used to;
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Frequently Ask Questions"
              name="2"
              class="pb-2"
            >
              <div class="pl-3">
                Visual feedback: reflect current state by updating or
                rearranging elements of the page.
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Frequently Ask Questions"
              name="3"
              class="pb-2"
            >
              <div class="pl-3">
                Definite and clear: enunciate your intentions clearly so that
                the users can quickly understand and make decisions;
              </div>
            </el-collapse-item>
            <el-collapse-item
              title="Frequently Ask Questions"
              name="4"
              class=""
            >
              <div class="pl-3">
                Controlled consequences: users should be granted the freedom to
                operate, including canceling, aborting or terminating current
                operation.
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
    <div class="lg:w-3/5 pt-12">
      <div class="custplanoverview p-4">
        <h2 class="text-black font-high fsize20 pb-2">Explore</h2>
        <p class="pb-2">
          Designed exclusively for visitors seeking a glimpse into our offerings
        </p>
        <hr class="bg-black" />
        <div class="flex justify-between py-4">
          <p class="text-black font-medium">Cost</p>
          -
          <p>2000</p>
          0
        </div>
        <div class="flex justify-between py-4">
          <p class="text-black font-medium">Coupon Discount</p>
          -
          <p>-150</p>
        </div>
        <div class="flex justify-between py-4">
          <p class="text-black font-medium">Tax.</p>
          -
          <p>00</p>
        </div>
        <hr class="bg-black" />
        <div class="flex justify-between py-4">
          <p class="text-black font-semibold fsize18px">Total</p>

          <p class="text-primary font-semibold fsize18px">₹1,850</p>
        </div>
        <div class="flex gap-2 justify-between py-1">
          <el-input></el-input>

          <button class="bg-00adc0 text-white px-8 rounded-md">Apply</button>
        </div>
        <div class="pt-3">
          <button class="bg-primary text-white w-full py-2 rounded-md">
            Checkout
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.h-200px {
  height: 200px;
}

.custelcollapse .el-collapse-item__header {
  padding-left: 10px;
  color: #4f0a4b;
  font-size: 16px;
  background: #c3c3c338;
  border-radius: 4px;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.h-130px {
  height: 130px;
}
.custelcollapse1 .el-collapse-item__header {
  padding-left: 10px;
  font-size: 16px;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-radius: 4px;
}
.bg-00adc0 {
  background: #00adc0;
}
</style>
